import { cartAdministration } from './cart-administration-de.i18n';

export const de = {
  cartAdministration,
};
